import {FAQSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  Accordion,
  GenericIconName,
  Icon,
  Paper,
  Text,
} from '@aboutyou/ui-components';
import {isCaseTypeCheck} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import React from 'react';
import {Link} from '../../../features/Link/Link';

export const BasketFAQView: React.FC<FAQSection> = ({type}) => {
  const {t} = useTranslation();
  if (
    !isCaseTypeCheck('articleList', type) ||
    !type.articleList.article.length
  ) {
    return null;
  }
  const {article: articles} = type.articleList;

  return (
    <StyledPaper
      headline={
        <>
          <Text
            data-testid="faqHeaderText"
            color="Black"
            size="px16"
            weight="w500"
          >
            {t('Do You have any questions?')}
          </Text>
          <ClickableLink
            data-testid="faqHeaderLink"
            label=""
            linkTarget={{url: '/h', external: false}}
          >
            <TextWithIcon size="px14" weight="w400">
              {t('Help')}
              <Icon size="S" asset={GenericIconName.ExternalLink} />
            </TextWithIcon>
          </ClickableLink>
        </>
      }
    >
      <div data-testid="faqContainer">
        {articles.map((article, index) => (
          <Accordion
            id={article.headline.substring(0, 5).replace(/\s+/g, '-')}
            key={index}
            content={
              <Text
                size="px14"
                weight="w400"
                dangerouslySetInnerHTML={{__html: article.headline}}
              />
            }
            toggleContent={
              <ArticleContent
                color="Grey1"
                size="px14"
                weight="w400"
                dangerouslySetInnerHTML={{
                  // This regex removes spaces between closing (>) and opening (<) tags to prevent incorrect spacing.
                  __html: article.text.replace(/>\s+</g, '><'),
                }}
                as="div"
              />
            }
          />
        ))}
      </div>
    </StyledPaper>
  );
};

const StyledPaper = styled(Paper)`
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
`;

const ArticleContent = styled(Text)`
  p {
    margin: 1rem 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const TextWithIcon = styled(Text)`
  display: flex;
  align-items: center;
`;

const ClickableLink = styled(Link)`
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
